import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import './scss/myUploadedCV.module.scss';
import api from '../../../../api/apiSettings';
import {
  appNotificationsTypes,
  CV_FILE_ALLOWED_FORMATS,
  MAX_CV_FILE_SIZE,
  validationMessages
} from '../../../../utils/constants';
import FileUploadField from '../../../common/FileUploadField/FileUploadField';
import { setNotification } from '../../../../actions/appNotifications';

function MyUploadedCV(props) {
  const { cvName } = props;
  const dispatch = useDispatch();
  const [isUploading, setIsUploading] = useState(false);
  const [fileName, setFileName] = useState(cvName);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  const validateInputFile = (inputFile) => {
    const currentErrors = [];
    if (!CV_FILE_ALLOWED_FORMATS.includes(inputFile?.name.toLowerCase().split('.').pop()))
      currentErrors.push(validationMessage.CV_ALLOWED_FORMATS);
    if (inputFile?.size > MAX_CV_FILE_SIZE) currentErrors.push(validationMessage.CV_ALLOWED_FILE_SIZE);
    return currentErrors;
  };

  const replaceFile = async (event) => {
    setErrors([]);
    const validationErrors = validateInputFile(event.target.files[0]);

    if (validationErrors.length) {
      setErrors(validationErrors);
      return;
    }

    const data = new FormData();
    data.append('cv', event.target.files[0]);

    try {
      setIsUploading(true);
      await api.post('v1/upload-cv', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch(
        setNotification({
          type: appNotificationsTypes.SUCCESS,
          message: 'CV / Resume has been updated successfully',
          duration: 3000
        })
      );
    } catch (error) {
      setErrors([validationMessage.CV_UPLOAD_FAILED]);
    } finally {
      setIsUploading(false);
    }

    setFileName(event.target.files[0].name);
  };

  useEffect(() => {
    if (cvName) setFileName(cvName);
  }, [cvName]);

  return (
    <div className="flex flex-row">
      <FileUploadField
        error={errors}
        file={file}
        fileName={fileName}
        setFile={setFile}
        setFileName={setFileName}
        setErrors={setErrors}
        validationMessage={validationMessage}
        showReplace={fileName}
        showClose={false}
        errors={errors}
        customClass="flex flex-col md:flex-row gap-4 items-center"
        customButtonClass="w-full h-[45px]"
        uploadText="Upload your"
        uploadHighlightText="CV / Resume"
        onFileChange={replaceFile}
        isUploading={isUploading}
      />
      {/* <span className="text-sm font-light">{fileName}</span>
      <label>
      <MainButton
        size='small'
        variant='textBlue'
        action={() => {}}
      >
        {t('dashboard.profile.replacefile')}
      </MainButton>
        <input type="file" accept=".pdf,.docx,.doc" hidden onChange={replaceFile} />
        </label> */}
      {/* <Button
        variant="outlined"
        color="primary"
        component="label"
        className={classes.uploadButton}
        sx={{
          textTransform: 'none'
        }}
      >
        {t('dashboard.profile.replacefile')}
        <input type="file" accept=".pdf,.docx,.doc" hidden onChange={replaceFile} />
      </Button> */}
      {/* </div>
      <div className="d-flex flex-column">
        {!!errors.length && errors.map((err) => <ValidationErrorLabel key={err} message={err} />)}
      </div> */}
    </div>
  );
}

export default MyUploadedCV;
